"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const icf_platform_client_1 = require("@atg/icf-platform-client");
const react_1 = __importDefault(require("react"));
const sanitizeBoundaryName_1 = __importDefault(require("../sanitizeBoundaryName"));
const Error_1 = __importDefault(require("./Error"));
class ErrorBoundaryInternal extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(_) {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        const boundaryName = (0, sanitizeBoundaryName_1.default)(this.props.boundaryName);
        void icf_platform_client_1.clientLogger.error({
            // eslint-disable-next-line @atg/no-dynamic-logs
            message: `Error in '${boundaryName}' caused ErrorBoundary to render.`,
            error,
            labels: { componentStackErrorInfo: info.componentStack },
        });
        void this.props.clientStatsd.increment({
            key: `errorBoundary.${boundaryName}`,
            amount: 1,
        });
    }
    render() {
        if (this.state.hasError) {
            if (typeof this.props.fallback !== "undefined") {
                return this.props.fallback;
            }
            else {
                return react_1.default.createElement(Error_1.default, null);
            }
        }
        else {
            return this.props.children;
        }
    }
}
const ErrorBoundary = (props) => {
    const statsd = (0, icf_platform_client_1.useStatsd)();
    return react_1.default.createElement(ErrorBoundaryInternal, { clientStatsd: statsd, ...props });
};
exports.default = ErrorBoundary;
